module.exports = __webpack_public_path__ + "static/sheepbathmain-05d2d9b898e1a78f88a69f4d7ccc48c2.png";